import Axios from "axios";

import { RouterEnum } from "../utils/routers";

export const Headers = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const PostConfig = (config) => ({
  method: "POST",
  headers: Headers(),
  ...config,
});

export const PatchConfig = () => ({
  method: "PATCH",
  headers: Headers(),
});

export const GetConfig = (config) => ({
  method: "GET",
  headers: Headers(),
  ...config,
});

export const DeleteConfig = () => ({
  method: "DELETE",
  mode: "cors",
  headers: Headers(),
});

export const Get = (url, onThen, onCatch, onFinally, config) => {
  Axios.get(url, GetConfig(config))
    .then((response) => {
      onThen(response);
    })
    .catch((exception) => {
      if (exception.response?.status !== 401) {
        onCatch(exception);
      } else {
         window.location = `${RouterEnum.Dashboard.Path}`;
      }
    })
    .finally(() => {
      if (onFinally !== undefined) onFinally();
    });
};

export const Post = (url, data, onThen, onCatch, onFinally, config) => {
  Axios.post(url, data, PostConfig(config))
    .then((response) => {
      onThen(response);
    })
    .catch((exception) => {
      if (exception.response?.status !== 401) {
        onCatch(exception);
      } else {
         window.location = `${RouterEnum.Dashboard.Path}`;
      }
    })
    .finally(() => {
      if (onFinally !== undefined) onFinally();
    });
};

export const Patch = (url, data) =>
  Axios.patch(url, data, PatchConfig()).catch((exception) => {
    if (exception.response?.status !== 401) return;

    window.location = `${RouterEnum.Dashboard.Path}`;
  });

export const Delete = (url) =>
  Axios.patch(url, DeleteConfig()).catch((exception) => {
    if (exception.response?.status !== 401) return;

    window.location = `${RouterEnum.Dashboard.Path}`;
  });
